<div class="user-card">
  <div class="user-card__inner">
    <h2 class="user-card__title">My Applications</h2>
    <div class="user-card__grid">
      <div class="overflow-auto rounded-[18px] border border-[#e2e8f0]">
        @if (isLoadingVendors) {
          <div class="h-full flex items-center justify-center">
            <div class="flex flex-col items-center gap-3">
              <div
                class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600"
              ></div>
              <p class="text-sm font-medium text-slate-500 text-center">
                Loading vendors...
              </p>
            </div>
          </div>
        } @else {
          <div class="size-full flex flex-col">
            <div class="p-3">
              <div class="relative w-full sm:w-[520px]">
                <svg
                  class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <button
                  type="button"
                  (click)="openFilters()"
                  class="w-full pl-9 pr-4 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg text-left text-slate-700 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all duration-200"
                >
                  {{
                    activeFilterCount
                      ? activeFilterCount +
                        " active filter" +
                        (activeFilterCount > 1 ? "s" : "")
                      : "Search and filter applications"
                  }}
                </button>
              </div>
            </div>
            <div class="grow overflow-x-auto">
              <table class="user-table">
                <thead>
                  <tr>
                    <th>App ID</th>
                    <th>MDA</th>
                    <th>Nature of Service</th>
                    <th>Category</th>
                    <th>Approval Status</th>
                    <th>Payment Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of vendors; track $index; let i = $index) {
                    <tr
                      (click)="selectVendor(v)"
                      [class.is-active]="selectedVendor?.id === v.id"
                    >
                      <td>{{ v.vendorReference || v.id }}</td>
                      <td>{{ v.mdaName || 'N/A' }}</td>
                      <td>{{ v.natureOfService || 'N/A' }}</td>
                      <td>{{ v.categoryName || 'N/A' }}</td>
                      <td>
                        <div
                          class="size-fit py-1 px-3 font-bold"
                          [class]="getApplicationStatusColor(v.approvalStatus)"
                        >
                          {{ v.approvalStatus || 'N/A' }}
                        </div>
                      </td>
                      <td>
                        <div
                          class="size-fit py-1 px-3 bg-gray-50 text-xs rounded-2xl"
                          [class]="getPaymentStatusColor(v.paymentStatus)"
                        >
                          {{ v.paymentStatus || 'N/A' }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-center vendor-actions">
                        <app-dropdown-menu>
                          <button
                            type="button"
                            class="toggle-btn"
                            aria-label="Vendor actions"
                            trigger
                          >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                              <path
                              d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z"
                              />
                            </svg>
                          </button>
                          <ng-container content>
                            @if (v.approvalStatus !== "APPROVED" && authenticationService.hasPermissions(["CAN_EDIT_Vendor_Management"])) {
                              <button
                                [routerLink]="[v.id, 'edit']"
                                type="button"
                                class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4 text-slate-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                  />
                                </svg>
                                Edit
                              </button>
                            }

                            @if (v.paymentStatus.toUpperCase() === 'PAID') {
                              <button (click)="handleReceiptDownload(v.id)"
                                type="button"
                                class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                                <svg class="size-4" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_11_834)">
                                    <path d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73479 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V4M7 1C7.15828 0.999745 7.31504 1.0308 7.46127 1.09139C7.60749 1.15197 7.74028 1.24088 7.852 1.353L9.646 3.147C9.75842 3.25875 9.84759 3.39167 9.90835 3.53808C9.96911 3.68449 10.0003 3.84149 10 4M7 1V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24021 3.94732 7.36739 4 7.5 4L10 4M6 9V6M7.5 7.5L6 9L4.5 7.5" stroke="#595A69" stroke-linecap="round" stroke-linejoin="round"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_11_834">
                                      <rect width="12" height="12" fill="white"/>
                                    </clipPath>
                                  </defs>
                                </svg>
                                Download Payment Receipt
                              </button>
                              <button (click)="handleCertificateDownload(v.id)"
                                type="button"
                                class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                                <svg class="size-4" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_11_834)">
                                    <path d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73479 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V4M7 1C7.15828 0.999745 7.31504 1.0308 7.46127 1.09139C7.60749 1.15197 7.74028 1.24088 7.852 1.353L9.646 3.147C9.75842 3.25875 9.84759 3.39167 9.90835 3.53808C9.96911 3.68449 10.0003 3.84149 10 4M7 1V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24021 3.94732 7.36739 4 7.5 4L10 4M6 9V6M7.5 7.5L6 9L4.5 7.5" stroke="#595A69" stroke-linecap="round" stroke-linejoin="round"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_11_834">
                                      <rect width="12" height="12" fill="white"/>
                                    </clipPath>
                                  </defs>
                                </svg>
                                Download Certificate
                              </button>
                            } @else if (v.paymentStatus.toUpperCase() !== 'PAID' && v.approvalStatus.toUpperCase() === "APPROVED") {
                              <button
                                [routerLink]="['/user', 'payment', 'make-payment', v.id]"
                                [queryParams]="{'application-type': 'VENDOR'}"
                                type="button"
                                class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                                <svg
                                  class="size-4 text-slate-500"
                                  stroke="currentColor"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M1.33594 6.66927H14.6693M2.66927 3.33594H13.3359C14.0723 3.33594 14.6693 3.93289 14.6693 4.66927V11.3359C14.6693 12.0723 14.0723 12.6693 13.3359 12.6693H2.66927C1.93289 12.6693 1.33594 12.0723 1.33594 11.3359V4.66927C1.33594 3.93289 1.93289 3.33594 2.66927 3.33594Z" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                Make Payment
                              </button>
                              <button
                                (click)="handlePaymentReconciliation(v.id)"
                                type="button"
                                class="w-fit px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                              <svg class="size-5" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path fill="currentColor" d="m11.825 6.455l-.009-.006l-.793-.533a3 3 0 0 0-3.626.211L5.45 7.796a.75.75 0 0 1-.488.18H2.75a.75.75 0 0 0-.75.75v6.03c0 .414.336.75.75.75h2.088a.75.75 0 0 1 .563.254l2.339 2.66a2.25 2.25 0 0 0 2.968.365l.684-.473l.734.25a2.25 2.25 0 0 0 2.539-.803l.47-.642l.326.044a2.25 2.25 0 0 0 2.276-1.153l.049-.09h3.464a.75.75 0 0 0 .75-.75V8.727a.75.75 0 0 0-.75-.75h-2.211a.75.75 0 0 1-.49-.182L16.86 6.336a3.75 3.75 0 0 0-5.036.12m-1.64.705l.562.378l-1.96 1.971a2.25 2.25 0 0 0 .044 3.216l.068.064c.81.771 2.062.831 2.941.14l2.079-1.632l2.657 2.555a.75.75 0 0 1 .139.9l-.025.044l-.014.026l-.255.467a.75.75 0 0 1-.758.384l-.769-.103a.75.75 0 0 0-.705.3l-.734 1.002a.75.75 0 0 1-.846.268l-1.09-.37a.75.75 0 0 0-.668.093l-.994.687a.75.75 0 0 1-.99-.122l-2.339-2.66a2.25 2.25 0 0 0-1.69-.763H3.5v-4.53h1.461a2.25 2.25 0 0 0 1.464-.541l1.948-1.669a1.5 1.5 0 0 1 1.813-.106m8.12 7.259a2.25 2.25 0 0 0-.69-1.648l-2.521-2.424a.75.75 0 0 0-1.053-1.053l-.506.397l-.06.047l-2.562 2.013a.75.75 0 0 1-.981-.047l-.068-.065a.75.75 0 0 1-.015-1.072l2.965-2.98a2.25 2.25 0 0 1 3.066-.116l1.687 1.458a2.25 2.25 0 0 0 1.472.547h1.46v4.943z" />
                              </svg>
                                Reconcile Payment
                              </button>
                              <button (click)="handleDemandNoticeDownload(v.id)"
                                type="button"
                                class="w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
                              >
                                <svg class="size-4" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_11_834)">
                                    <path d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73479 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V4M7 1C7.15828 0.999745 7.31504 1.0308 7.46127 1.09139C7.60749 1.15197 7.74028 1.24088 7.852 1.353L9.646 3.147C9.75842 3.25875 9.84759 3.39167 9.90835 3.53808C9.96911 3.68449 10.0003 3.84149 10 4M7 1V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24021 3.94732 7.36739 4 7.5 4L10 4M6 9V6M7.5 7.5L6 9L4.5 7.5" stroke="#595A69" stroke-linecap="round" stroke-linejoin="round"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_11_834">
                                      <rect width="12" height="12" fill="white"/>
                                    </clipPath>
                                  </defs>
                                </svg>
                                Download Demand Notice
                              </button>
                            }
                          </ng-container>
                          <!-- Temporarily hidden (per request): Deactivate / Blacklist actions -->
                        </app-dropdown-menu>
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="7" class="user-empty">No applications found.</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div
              class="flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-slate-50/50"
            >
              <p class="text-xs text-slate-400">
                Showing {{ vendors.length }} of {{ totalItems }} vendors
              </p>
              <div class="flex items-center gap-1">
                <button
                  (click)="goToPreviousPage()"
                  [disabled]="!hasPreviousPage"
                  class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
                >
                  Previous
                </button>
                <button
                  class="px-3 py-1.5 text-xs bg-vms-bg-secondary text-vms-text-secondary rounded-md shadow-sm"
                >
                  {{ currentPage }}
                </button>
                <button
                  (click)="goToNextPage()"
                  [disabled]="!hasNextPage"
                  class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="user-detail" *ngIf="selectedVendor; else emptyState">
        <div class="user-detail__header">
          <div>
            <div class="flex items-start gap-3">
              <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.4243 30.5057H35.5935M25.4243 20.3365H35.5935M35.5935 53.3864V45.7595C35.5935 44.411 35.0578 43.1177 34.1043 42.1642C33.1508 41.2106 31.8575 40.6749 30.5089 40.6749C29.1604 40.6749 27.8671 41.2106 26.9136 42.1642C25.96 43.1177 25.4243 44.411 25.4243 45.7595V53.3864M15.2551 25.4211H10.1705C8.82202 25.4211 7.52873 25.9568 6.57518 26.9104C5.62163 27.8639 5.08594 29.1572 5.08594 30.5057V48.3018C5.08594 49.6503 5.62163 50.9436 6.57518 51.8972C7.52873 52.8507 8.82202 53.3864 10.1705 53.3864H50.8474C52.1959 53.3864 53.4892 52.8507 54.4427 51.8972C55.3963 50.9436 55.932 49.6503 55.932 48.3018V22.8788C55.932 21.5303 55.3963 20.237 54.4427 19.2834C53.4892 18.3299 52.1959 17.7942 50.8474 17.7942H45.7627M15.2551 53.3864V12.7096C15.2551 11.3611 15.7908 10.0678 16.7444 9.11425C17.6979 8.1607 18.9912 7.625 20.3397 7.625H40.6781C42.0267 7.625 43.32 8.1607 44.2735 9.11425C45.2271 10.0678 45.7627 11.3611 45.7627 12.7096V53.3864" stroke="#00637C" stroke-width="3.72039" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>
                <div class="user-detail__name">{{ selectedVendor.name }}</div>
                <div class="user-detail__meta">
                  {{ selectedVendor.vendorReference }} &nbsp; | &nbsp; ASIN-{{ selectedVendor.asin || 'N/A' }}
                </div>
                <div class="user-detail__tag">Category {{ selectedVendor.categoryName || 'N/A' }}</div>
              </div>
            </div>
          </div>
          <div class="user-detail__pill" [class]="getApplicationStatusPillColor(selectedVendor.approvalStatus)">
            {{ selectedVendor.approvalStatus || 'PENDING' }}
          </div>
        </div>

        <div>
          <div class="mt-6 flex flex-wrap justify-between gap-1">
            <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'overview'" (click)="tab = 'overview'">
              Overview
            </button>
            <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'directors'" (click)="tab = 'directors'">
              Directors
            </button>
            <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'bank'" (click)="tab = 'bank'">
              Bank Details
            </button>
            <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'documents'" (click)="tab = 'documents'">
              Documents
            </button>
            <button type="button" class="tab-pill" [class.tab-pill--active]="tab === 'comments'" (click)="tab = 'comments'">
              Comments
            </button>
          </div>
        </div>

        <div class="user-detail__kv">
          @if (isLoadingVendorDetails) {
            <div class="h-full flex items-center justify-center">
              <div class="flex flex-col items-center gap-3">
                <div
                  class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600"
                ></div>
                <p class="text-sm font-medium text-slate-500 text-center">
                  Loading vendor details...
                </p>
              </div>
            </div>
          } @else {
            @switch (tab) {
              @case ('overview') {
                <div class="kv"><span>Phone</span><strong>{{ selectedVendor.phoneNo || 'N/A' }}</strong></div>
                <div class="kv"><span>Address</span><strong>{{ selectedVendor.address || 'N/A' }}</strong></div>
                <div class="kv"><span>RC Number</span><strong>{{ selectedVendor.rcNumber || 'N/A' }}</strong></div>
                <div class="kv"><span>Business Classification</span><strong>{{ selectedVendor.businessClassification || 'N/A' }}</strong></div>
                <div class="kv"><span>Date of Incorporation</span><strong>{{ selectedVendor.dateOfIncorporation || 'N/A' }}</strong></div>
                <div class="kv"><span>TIN</span><strong>{{ selectedVendor.tin || 'N/A' }}</strong></div>
                <div class="kv"><span>MDA Association</span><strong>{{ selectedVendor.mdaName || 'N/A' }}</strong></div>
                <div class="kv"><span>Nature of Service</span><strong>{{ selectedVendor.natureOfService || 'N/A' }}</strong></div>
                <div class="kv"><span>Vendor Type</span><strong>{{ selectedVendor.vendorType || 'N/A' }}</strong></div>
              }
              @case ('directors') {
                <div class="space-y-6">
                  @for (director of vendorDetails.directors; track $index; let i = $index) {
                    <div>
                      <p class="mb-2 text-lg font-bold">Director {{i + 1}}</p>
                      <div class="kv"><span>ASIN</span><strong>{{ director.asin }}</strong></div>
                      <div class="kv"><span>Name</span><strong>{{ director.asin }}</strong></div>
                      <div class="kv"><span>Phone Number</span><strong>{{ director.phone || 'N/A' }}</strong></div>
                      <div class="kv"><span>Email</span><strong>{{ director.email || 'N/A' }}</strong></div>
                      <div class="kv"><span>Address</span><strong>{{ director.address || 'N/A' }}</strong></div>
                      <div class="kv"><span>BVN</span><strong>{{ director.bvn }}</strong></div>
                    </div>

                    @if (i < vendorDetails.directors.length) {
                      <hr class="border border-dashed">
                    }
                  }
                </div>
              }
              @case ('bank') {
                <div class="kv"><span>Account Number</span><strong>{{ vendorDetails.bankDetails.accountNumber }}</strong></div>
                <div class="kv"><span>Account Name</span><strong>{{ vendorDetails.bankDetails.accountName || 'N/A' }}</strong></div>
                <div class="kv"><span>Bank</span><strong>{{ vendorDetails.bankDetails.bankName || 'N/A' }}</strong></div>
              }
              @case ('documents') {
                <div class="space-y-4">
                  @for (document of vendorDetails.documents; track $index) {
                    <div class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4">
                      <div class="flex min-w-[240px] items-center gap-4">
                        <div class="h-10 w-10 rounded-xl bg-slate-50 grid place-items-center border border-slate-200">
                          <span class="text-xs font-semibold text-red-500">PDF</span>
                        </div>
                        <div class="min-w-0">
                          <a
                            class="page-link truncate"
                            [href]="document.uploaded_document_url || '#'"
                            target="_blank"
                            rel="noopener noreferrer"
                          >{{ document.name }}</a>
                          <div class="mt-1 text-sm text-slate-400">Uploaded: {{ document.uploadedAt }}</div>
                        </div>
                      </div>

                      @if ((vendorDetails.approvalStatus || '').toUpperCase() === 'APPROVED') {
                        <span class="inline-flex items-center rounded-full bg-sky-100 px-4 py-1.5 text-sm font-medium text-sky-700">
                          Verified
                        </span>
                      } @else {
                        <span class="inline-flex items-center rounded-full bg-amber-100 px-4 py-1.5 text-sm font-medium text-amber-700">
                          Pending
                        </span>
                      }
                    </div>
                  }
                </div>
              }
              @case ('comments') {
                <div class="space-y-6">
                  @for (comment of vendorDetails?.comments; track $index; let i = $index) {
                    <div>
                      <p class="mb-2 text-lg font-bold">Comment {{i + 1}}</p>
                      <div class="kv"><span>User</span><strong>{{ comment?.user || 'N/A' }}</strong></div>
                      <div class="kv"><span>Comment</span><strong>{{ comment?.comment || 'N/A' }}</strong></div>
                      <div class="kv"><span>Created On</span><strong>{{ (comment?.createdAt | date:'dd/MM/yyyy') || 'N/A' }}</strong></div>
                    </div>

                    @if (i < vendorDetails?.directors?.length) {
                      <hr class="border border-dashed">
                    }
                  } @empty {
                    <div>No comments</div>
                  }
                </div>
              }
            }
          }
        </div>
      </div>

      <ng-template #emptyState>
        <div class="user-empty">Select an application to view details.</div>
      </ng-template>
    </div>
  </div>
</div>

<app-filter-drawer
  [isOpen]="isFilterDrawerOpen"
  title="Filters"
  subtitle="Search and filter vendors."
  submitLabel="Apply Filters"
  resetLabel="Clear all"
  [fields]="vendorFilterFields"
  [initialValue]="vendorFilters"
  (close)="closeFilters()"
  (apply)="applyFilters($event)"
></app-filter-drawer>
